import type { MedicationPadItemType } from '@/components/Patient/components/PrescriptionPad/PrescriptionPad.types';
import type { ProductFormulation } from '@/constants/products';
import { hasUnreadableNetWeight } from './calculateDispenseAmount';
import { getFormulationFilter } from './getFormulationFilter';

/**
 * Whether any pad item of the formulation has a product whose net weight is missing or unreadable. Dispense amounts
 * and limits are then left off for the whole formulation, rather than shown for only some of its products.
 */
export const formulationHasUnreadableNetWeight = (
  medicationPadItems: MedicationPadItemType[],
  formulation: ProductFormulation | undefined,
) =>
  formulation !== undefined &&
  medicationPadItems.some(
    ({ medicationPadItem, filters }) =>
      getFormulationFilter(filters) === formulation && hasUnreadableNetWeight(medicationPadItem),
  );
